const softwareList = [
  {
    label: '3shape',
    value: '3shape',
  },
  {
    label: 'Archform',
    value: 'Archform',
  },
  {
    label: 'Maestro',
    value: 'Maestro',
  },
  {
    label: 'Nemocast',
    value: 'Nemocast',
  },
  {
    label: 'Onyxceph',
    value: 'Onyxceph',
  },
  {
    label: 'Softsmile',
    value: 'Softsmile',
  },
  {
    label: 'Others',
    value: 'Others',
  },
]

export default softwareList
